import { Dispatch, FC, SetStateAction, useContext, useState } from 'react';
import { RegionCountsMap } from 'services/api/admin';
import createNamedContext from 'utils/createNamedContext';

export interface StoreInfo {
  storeScopes?: General.StoreScope[];
  storeCountData?: RegionCountsMap;
}

interface StoreContextValue {
  storeInfo: StoreInfo;
  setStoreInfo: Dispatch<SetStateAction<StoreInfo>>;
}

export const StoreContext = createNamedContext<StoreContextValue | null>('StoreContext', null);

export const useStoreContext = () => {
  const value = useContext(StoreContext);

  if (!value) {
    throw new Error(
      'useStoreContext hook should be used in a context of StoreContextProvider component',
    );
  }

  return value;
};

export const StoreContextProvider: FC = (props) => {
  const [storeInfo, setStoreInfo] = useState<StoreInfo>({});

  return (
    <StoreContext.Provider
      value={{
        storeInfo,
        setStoreInfo,
      }}
      {...props}
    />
  );
};
